import { FC, useEffect, useState } from 'react'; 
import Modal from '../../components/shared/Modal/Modal';
import { useTranslation } from 'react-i18next';
import StyledCheckbox from '../../components/shared/StyledCheckbox/StyledCheckbox';
import styles from './ApproveAdModal.module.scss';

type Props = {
  show: boolean,
  setShow: (value: boolean) => void,
  onSubmit: () => void,
  applicant: { name: string, email: string },
  companyName: string,
}

const ApproveAdModal : FC<Props> = ({ show, setShow, onSubmit, applicant, companyName }) => {
  const [t] = useTranslation("supplierDatabase");
  const [canRecommend, setCanRecommend] = useState(false);
  const [authorized, setAuthorized] = useState(false);

  useEffect(() => {
    setCanRecommend(false);
    setAuthorized(false);
  }, [show]);

  return (
    <Modal
      show={show}
      setShow={setShow}
      title={t('adApplication.approveForm.heading', 'Godkänn ansökan')}
      buttonInfo={{
        label: t('adApplication.approveForm.button.send', 'Godkänn'),
        action: () => {
          onSubmit();
          setShow(false);
        },
        disabled: !(canRecommend && authorized),
      }}
    >
      
      <div className={styles.container}>
        <label>
          <StyledCheckbox className={styles.checkbox} checked={canRecommend} onChange={() => setCanRecommend(!canRecommend)} />
          {t('adApplication.approveForm.label.recommended', 'Vi kan rekommendera leverantören: kontrollerat kreditvärdighet, kollektivavtal, ID06, sanktionslistor, etc.')}
        </label>
        <label>
          <StyledCheckbox className={styles.checkbox} checked={authorized} onChange={() => setAuthorized(!authorized)} />
          {t('adApplication.approveForm.label.authorized', '{{applicantName}} ({{applicantEmail}}) är behörig representant för {{companyName}} (t.ex. personen finns på företagets hemsida med samma e-postadress eller du har ringt företagets telefonnummer och kontrollerat).', {
            applicantName: applicant.name,
            applicantEmail: applicant.email,
            companyName,
          })}
        </label>
      </div>
    </Modal>
  );
}

export default ApproveAdModal;